import { Stack } from '@mui/material';
import { useAppStore } from '@/modules/app/store/useAppStore';
import { DefaultHeader } from './DefaultHeader';
import { SelectionHeader } from './SelectionHeader';
import { Panel_Display_Mode } from '@/modules/floorplanDesign/types';
import { AreaDetails } from './AreaDetails';

export const Header = () => {
  const panelModeState = useAppStore((state) => state.panelModeState);

  return (
    <Stack gap={0}>
      {panelModeState === Panel_Display_Mode.NONE ? (
        <DefaultHeader />
      ) : (
        <>
          <SelectionHeader panelModeState={panelModeState} />

          <AreaDetails />
        </>
      )}
    </Stack>
  );
};
